export default __webpack_public_path__ + "static/svami-d6b61dff1cf1fcd408ea4d0b809a7269.png";